import { Record } from 'immutable';
import { EntityTypes } from '../schemas';

export default class PersonRecord extends Record({
  id: null,
  firstName: null,
  lastName: null,
  name: null,
  phone1: null,
  phone2: null,
  phone3: null,
  phone4: null,
  email: null,
  information: null,
  createdAt: null,
  createdBy: null,
  contacts: null,
  gdprAcceptedAt: null,
  type: EntityTypes.Person,
}) {
}
